<template>
  <div>
    <PageTitle
      title="Edit Dish"
      :backBtn="true"
      :permission="'Customer Create'"
      :showLoading="isLoading"
    />
    <ValidationObserver ref="observer">
      <v-container fluid class="lighten-12">
        <v-row>
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <v-card class="lighten-12">
                  <v-card-title>General </v-card-title>
                  <v-container
                    fluid
                    class="light gray lighten-12 container-card"
                  >
                    <form>
                      <v-row>
                        <template v-if="messages">
                          <v-alert
                            v-for="msg in messages"
                            :key="msg"
                            class="messages"
                            dense
                            outlined
                            type="error"
                            >{{ msg }}</v-alert
                          >
                        </template>
                      </v-row>

                      <v-row>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name=" Name"
                            rules="required|no_spaces_only"
                            vid="name"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              v-model="Dish.name"
                              :error-messages="errors"
                              label="Name"
                             required
                             @blur="Dish.name = Dish.name.trim()"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Code"
                            rules="required|no_spaces_only"
                            vid="code"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              v-model="Dish.code"
                              :error-messages="errors"
                              label="Code"
                              required
                              @blur="Dish.code = Dish.code.trim()"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Average Cooking Time"
                            rules="duration_cook_time"
                            vid="avrage_gooking_time"
                          >
                            <v-text-field
                              hide-details="auto"
                              dense
                              outlined
                              label="Average Cooking Time"
                              placeholder="Minutes (e.g. 15) or HH:MM (e.g. 01:15)"
                              prepend-icon="mdi-timer-outline"
                              v-model="Dish.avrage_gooking_time"
                              :error-messages="errors"
                              @blur="
                                Dish.avrage_gooking_time = normalizeCookingTime(
                                  Dish.avrage_gooking_time
                                )
                              "
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                          <ValidationProvider
                            v-slot="{ errors }"
                            name="Is Ready Made"
                            rules="required"
                          >
                            <v-select
                              hide-details="auto"
                              dense
                              item-text="name"
                              item-value="value"
                              :items="status"
                              :error-messages="errors"
                              v-model="Dish.is_ready_made"
                              label="Is Ready Made"
                              outlined
                            ></v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </form>
                  </v-container>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-row>
                  <v-col cols="12" md="12" class="pa-3">
                    <v-card class>
                      <v-tabs v-model="tab" background-color="white" color="primary" slider-color="primary">
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab
                          :disabled="item.disabled"
                          v-for="item in items"
                          :key="item.tab"
                        >
                          {{ item.tab }}
                        </v-tab>
                      </v-tabs>
                      <v-tabs-items v-model="tab">
                        <v-tab-item
                          v-for="(item, index) in items"
                          :key="item.tab"
                        >
                          <Category
                            v-if="item.tab === 'Categories' && Dish.categories && Dish.categories.length > 0"
                            ref="Categories"
                            :DishCategory="Dish.categories[0].id"
                            v-on:nextTab="moveTab(1, index)"
                            @save="saveCategories"
                          />
                          <Ingredients
                            v-if="item.tab === 'Ingredients'"
                            @nextTab="GetDataIngreients()"
                            @save="saveIngredients"
                            :selectedIngredientsData="Dish.ingredients"
                            ref="Ingredients"
                          />
                          <Types
                            v-if="item.tab === 'Types'"
                            ref="Types"
                            :selectedTypeData="Dish.types"
                            @nextTab="moveTab(2, index)"
                            @save="saveTypes"
                          />
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="4">
            <v-card>
              <v-flex class="pt-0 pa-1">
                <FileUpload
                  title="Image"
                  @isImageUpdated="onChangeImageUpload"
                  :multiple="false"
                  v-model="selectedImages"
                  :externalFiles="Dish.image ? [Dish.image] : []"
                  size="10000"
                  :types="['jpeg', 'png', 'jpg']"
                  :showPreview="true"
                  :camera="true"
                />
              </v-flex>
            </v-card>
          </v-col>
        </v-row>

        <v-row> </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="12" class="content-flex-end">
            <v-btn depressed small class="text-white btn_medium" @click="clear"
              >Clear</v-btn
            >
            <v-btn
              depressed
              small
              class="text-white btn_blue btn_medium w-100"
              @click="submit"
              :disabled="isDisabledSubmit"
              >Submit</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </ValidationObserver>
  </div>
</template>

<script>
import { required, email, max, regex } from "vee-validate/dist/rules";
import Category from "./DishCategory/DishCategoryEdit";
import Types from "./DishType/DishTypesEdit";
import Ingredients from "./DIshIngredient/DishIngredientsEdit";
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";

import { Dishes } from "../../../models/Dishes";
import { ProductCategory } from "../../../models/ProductCategory";
import FileUpload from "@/components/base/FileUpload";
setInteractionMode("eager");

extend("required", {
  ...required,
  message: "{_field_} is required",
});

extend("duration_cook_time", {
  validate: (value) => {
    if (value === null || value === undefined) return true;
    const raw = String(value).trim();
    if (!raw) return true;

    if (/^\d+$/.test(raw)) return true;

    const match = raw.match(/^(\d{1,2})\s*:\s*(\d{1,2})$/);
    if (!match) return false;
    const hours = parseInt(match[1], 10);
    const minutes = parseInt(match[2], 10);
    if (!Number.isFinite(hours) || hours < 0) return false;
    if (!Number.isFinite(minutes) || minutes < 0 || minutes > 59) return false;
    return true;
  },
  message: "Use minutes (e.g. 15) or HH:MM (e.g. 01:15)",
});

extend("email", {
  ...email,
  message: "Email must be valid",
});

export default {
  data: () => ({
    selectedImages: "",
    status: [
      {
        name: "Yes",
        value: true,
      },
      {
        name: "No",
        value: false,
      },
    ],
    items: [
      { tab: "Categories", content: "this is credit tab", disabled: false },
      { tab: "Types", content: "this is credit tab", disabled: false },
      { tab: "Ingredients", content: "", disabled: false },
    ],
    tab: "Credit",
    checkbox: null,
    Dish: new Dishes(),
    isLoading: false,
    GetProductCategory: [],
    imageUpdated: null,
    selectedCategory: [],
    selectedTypes: [],
    selectedIngredients: [],
    errors: [],
    messages: [],

    isDisabledSubmit: false,
    countries: { id: "", name: "" },
  }),
  components: {
    Category,
    Ingredients,
    Types,
    ValidationProvider,
    ValidationObserver,
    FileUpload,
  },

  props: {
    CategoryData: {
      type: Boolean,
      default: false,
    },
    IngredientData: {
      type: Array,
      default: [],
    },
    productcategory: {
      type: Object,
      default: {},
    },
  },
  methods: {
    normalizeCookingTime(value) {
      if (value === null || value === undefined) return "";
      const raw = String(value).trim();
      if (!raw) return "";

      if (/^\d+$/.test(raw)) {
        return String(parseInt(raw, 10));
      }

      const match = raw.match(/^(\d{1,2})\s*:\s*(\d{1,2})$/);
      if (!match) return raw;

      const hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      if (!Number.isFinite(hours) || !Number.isFinite(minutes)) return raw;

      const hh = String(hours).padStart(2, "0");
      const mm = String(minutes).padStart(2, "0");
      return `${hh}:${mm}`;
    },
    GetCategoryDatas(event) {
      this.selectedCategory = event;
    },
    GetDataIngreients() {
      if (this.$refs.Ingredients.length == 1) {
        this.selectedIngredients = this.$refs.Ingredients[0].GetDatasIngredients();
      } else {
        this.selectedIngredients = this.$refs.Ingredients.GetDatasIngredients();
      }
    },
    moveTab(to, index) {
      if (to == 1) {
        if (this.$refs.Categories.length == 1) {
          this.selectedCategory = this.$refs.Categories[0].GetDatas();
        } else {
          this.selectedCategory = this.$refs.Categories.GetDatas();
        }
      }

      if (to == 2) {
        if (this.$refs.Types.length == 1) {
          this.selectedTypes = this.$refs.Types[0].GetDatasTypes();
        } else {
          this.selectedTypes = this.$refs.Types.GetDatasTypes();
        }
      }

      this.tab = to;
      this.items[index + 1].disabled = false;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.UpdateDish();
      }
    },
    clear() {

      this.Dish = {};
      // this.Guest = new Dishes();
      // this.Guest = {};
      //this.$refs.observer.reset();
    },
    saveCategories(categories) {
      this.$store
        .dispatch("dish/UpdateDishCategories", {
          id: this.$route.params.id,
          categories,
        })
        .then(() => {
          this.selectedCategory = categories[0];
          this.$toast.success("Category updated");
        })
        .catch(() => {
          this.$toast.error("Could not update the category");
        });
    },
    saveTypes(types) {
      this.$store
        .dispatch("dish/UpdateDishTypes", {
          id: this.$route.params.id,
          types,
        })
        .then(() => {
          this.selectedTypes = types.map((type) => ({
            unit: { id: type.unit_id },
            price: type.price,
            is_adjust: type.is_adjust,
            quantity: type.quantity,
            is_default: type.is_default,
          }));
          this.$toast.success("Types updated");
        })
        .catch(() => {
          this.$toast.error("Could not update the types");
        });
    },
    saveIngredients(ingredients) {
      this.$store
        .dispatch("dish/UpdateDishIngredients", {
          id: this.$route.params.id,
          ingredients,
        })
        .then(() => {
          this.selectedIngredients = ingredients.map((item) => ({
            ingredient: { id: item.ingredient_id },
            price: item.price,
          }));
          this.$toast.success("Ingredients updated");
        })
        .catch(() => {
          this.$toast.error("Could not update the ingredients");
        });
    },
    GetSingleDishDetails() {
      let DishId = this.$route.params.id;
      this.$store
        .dispatch("dish/GetSingleDish", DishId)
        .then((res) => {
          this.Dish = new Dishes().Initialise(res.data);
          this.selectedCategory = this.Dish.categories[0].id;
          this.selectedTypes = this.Dish.types;
          this.selectedIngredients = this.Dish.ingredients;
        })
        .catch((err) => {
          this.messages = err.data.title;
        });
    },

    UpdateDish() {
      this.isLoading = true;
      this.isDisabledSubmit = true;

      let Credential = this.Dish;

      Credential.Categories = this.selectedCategory;
      Credential.Types = this.selectedTypes.map(function (item) {
        return {
          unit_id: item.unit ? item.unit.id : item.unit_id,
          price: item.price,
          is_default: item.is_default != null ? Boolean(item.is_default) : Boolean(item.sample),
          is_adjust: item.is_adjust ? item.is_adjust : false,
          quantity: item.quantity ? item.quantity : null,
        };
      });
      if (Credential.Types.length && !Credential.Types.some((type) => type.is_default)) {
        Credential.Types[0].is_default = true;
      }
      Credential.Ingredients = this.selectedIngredients.map(function (item) {
        return {
          ingredient_id: item.ingredient.id,
          price: item.price,
        };
      });

      this.$store
        .dispatch("dish/EditDish", new Dishes().toRequest(Credential))
        .then(async (res) => {
          this.succeeed = true;
          await this.UploadDishImage(Credential.id);

          this.isDisabledSubmit = false;
          this.$router.push("/dishes");
          this.$toast.success("Dish edited  successfully");
          this.isLoading = false;
        })
        .catch((err) => {
          this.$refs.observer.setErrors(err.data.error);
          this.messages = err.data.title;
          this.isLoading = false;
          this.isDisabledSubmit = false;
          this.$toast.error("Dish creation failed");
          // this.isDisabledSubmit = false;
        });
    },

    onChangeImageUpload(value) {
      this.imageUpdated = value;
    },

    async UploadDishImage(dishid) {
      let fromData = new FormData();

      if (this.selectedImages && this.imageUpdated) {
        fromData.append("image", this.selectedImages);
        fromData.append("id", dishid);
        return await this.$store
          .dispatch(`dish/UploadDishImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error("Dish image uploading failed");
          });
      } else if (this.imageUpdated == false) {
        fromData.append("image", this.selectedImages);
        fromData.append("id", dishid);
        return await this.$store
          .dispatch(`dish/UploadDishImage`, fromData)
          .then(() => {})
          .catch(() => {
            this.$toast.error("Dish image uploading failed");
          });
      } else {
        return true;
      }

      formData.append("id", id);
      console.log(this.selectedImages);
    },
  },
  created() {
    this.GetSingleDishDetails();
  },
};
</script>
